import { useCallback, useContext, useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks'
import { loadEntityLocations } from '@user/store/entityLocations/api'
import { useData } from '@user/components/Agreements/CreateAgreementDrawer/CreateAgreementForm/TemplateDetails/hooks/useData'
import { useActions } from '@user/components/Location/MatchCreateNew/CreateNew/hooks'
import { useHandlers } from '@user/components/Agreements/CreateAgreementDrawer/CreateAgreementForm/TemplateDetails/hooks/useHandlers'
import { LocationContext, LocationContextType } from '../context/context'
import { useCheckPermissions } from '@user/store/authorization/permissions'

export const useCreateLocations = () => {
  const dispatch = useAppDispatch()
  const [dataLoaded, setDataLoaded] = useState(false)

  const {
    state: { entityId, entityType },
  } = useContext<LocationContextType>(LocationContext)

  const [canCreateLocations] = useCheckPermissions('accounts_create')

  const createLocParams = useData({ entityId, entityType })
  const { saving, onSave, errors } = useActions({
    ...createLocParams,
    detail: true,
  })

  const { handleCreateNewLocation, openNewLocation, onCloseNewLocation } =
    useHandlers({
      ...createLocParams,
      onSave,
    })

  useEffect(() => {
    if (!dataLoaded || saving) return

    handleCreateNewLocation()
    setDataLoaded(false)
  }, [handleCreateNewLocation, dataLoaded, saving, setDataLoaded])

  const addToPestPac = useCallback(async () => {
    await dispatch(loadEntityLocations({ entityId, entityType }))
    setDataLoaded(true)
  }, [dispatch, entityId, entityType, loadEntityLocations, setDataLoaded])

  return {
    entityId,
    entityType,
    openNewLocation,
    onCloseNewLocation,
    handleCreateNewLocation,
    addToPestPac,
    saving,
    canCreateLocations,
    errors,
  }
}
